var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEternal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.1,53.9c0.5-5.5-0.9-14.6-3-19.6c-2-5-5-9.6-8.8-13.6l1.5-2.3l1.5-2.3l-19,0.2l7.2,18.5l1.4-2.1l1.4-2.1  c2.3,2.8,4,5.9,5.2,9.2c1.2,3.3,2,9.6,1.7,13.3l5.7-2.7L92.1,53.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2,12.1l-1.8-2.1l-1.8-2.1L22,26l19.8-1.1l-1.6-2l-1.6-2c3.4-1.3,6.9-2,10.4-2.1  c3.5-0.1,9.8,1.1,13.2,2.5l-0.9-6.2l5.2-4C61.3,9,52.2,7.5,46.8,7.9C41.4,8.3,36.1,9.7,31.2,12.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1,29.6L20,28.5l-2.2-6.2C14.2,26.5,9.9,34.7,8.6,40S7,50.7,7.8,56.1l-2.6,1l-2.6,1l15.5,11l5-19.2  L20.8,51l-2.4,0.9c-0.2-3.6,0.2-7.1,1.2-10.5C20.7,38,23.7,32.4,26.1,29.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1,86.2L41.5,75.5l0.2,2.5l0.2,2.5c-3.5-0.9-6.7-2.4-9.7-4.4c-2.9-2-7.3-6.6-9.2-9.8l-3,5.5l-6.5,0.2  c2.8,4.7,9.3,11.3,13.9,14.1c4.6,2.9,9.7,4.9,15.1,5.8l0.2,2.8l0.2,2.8L58.1,86.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7,71.5l-6.1-18.1L71.3,66l2.5,0.6l2.5,0.6c-1.9,3-4.4,5.7-7.2,7.8c-2.8,2.2-8.5,4.9-12.1,5.7l4.3,4.5  l-1.9,6.3c5.4-1.2,13.6-5.4,17.7-8.9s7.6-7.8,10.2-12.6l2.7,0.7L92.7,71.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEternal);
export default __webpack_public_path__ + "static/media/eternal.8e29587f238aeea7620ef29409398168.svg";
export { ForwardRef as ReactComponent };